/**
 * 由領域模型 `Task` 轉為甘特圖列資料的轉接器。
 *
 * 放在展示層是刻意的：核心模型不該知道 UI 需要哪些欄位；
 * 而整合層（store selector）只要呼叫這支函式即可。
 */

import type { BaselineTaskSnapshot, Task } from '@bigint-project/core';

import type { GanttTask } from './types.js';

export interface ToGanttTaskOptions {
  /** 條右側顯示的資源名稱，例 "Alice, Bob"。 */
  readonly resourceNames?: string;
  /** 對應的基準快照。 */
  readonly baseline?: BaselineTaskSnapshot | null;
  /** 落後預期的百分點（`expected − actual`）；未落後時省略。 */
  readonly behindPercent?: number | null;
}

export function toGanttTask(task: Task, options: ToGanttTaskOptions = {}): GanttTask {
  const baseline = options.baseline ?? null;
  return {
    id: task.id,
    name: task.name,
    wbs: task.wbs,
    outlineLevel: task.outlineLevel,
    start: task.start,
    finish: task.finish,
    percentComplete: task.percentComplete,
    isSummary: task.isSummary,
    isMilestone: task.isMilestone,
    isCritical: task.isCritical,
    isManuallyScheduled: task.isManuallyScheduled,
    resourceNames: options.resourceNames ?? '',
    baselineStart: baseline === null ? null : baseline.start,
    baselineFinish: baseline === null ? null : baseline.finish,
    behindPercent: options.behindPercent ?? null,
  };
}
